import type { InputHTMLAttributes, ReactNode } from 'react';

export function FormField({
  label,
  ...inputProps
}: InputHTMLAttributes<HTMLInputElement> & {
  label: ReactNode;
}) {
  return (
    <label>
      {label}
      <input {...inputProps} />
    </label>
  );
}
